import BaseService from './base.service'
import moment from 'moment';

import StatService from './stat.service';

class ProjectsService extends BaseService {
  get entity () {
    return 'project'
  }

  fetchSummary () {
    return this.request({ auth: true }).get('users/current/projects/summary')
      .then(response => response.data)
  }


  getEntityByProject(entityName, projectId) {

  }
  
  getReport() {
    
  }

  getAccountGroups(paramters={}, commit) {
    const params = {
      ...parameters
    }

    new Promise((resolved, rejected) => {
      return this.request({ auth: true }).get(`accounts/groups/`)
          .then(response => resolved(this.responseWrapper(response, response.data)))
          .catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          rejected(this.errorWrapper(error, message))
          })
      })
  }

  getCompleteProject(parameters = {}, commit) {
    const params = {
        ...parameters
    }
    const promises = [
        new Promise((resolved, rejected) => {
             return this.request({ auth: true }).get(`users/current/projects/${params.id}`)
                 .then(response => resolved(this.responseWrapper(response, response.data)))
                 .catch(error => {
                 let message = error.response.data ? error.response.data.error : error.response.statusText
                 rejected(this.errorWrapper(error, message))
                 })
         }),
         new Promise((resolved, rejected) => {    
            return this.request({auth: true}).get(`users/current/projects/${params.id}/bots`)
                 .then(response => resolved(this.responseWrapper(response, response.data)))
                 .catch(error => {
                 let message = '';//error.response.data ? error.response.data.error : error.response.statusText
                 rejected(this.errorWrapper(error, message))
                 })
         }),
         new Promise((resolved, rejected) => {
            return this.request({auth: true}).get(`users/current/projects/${params.id}/settings`)
                 .then(response => resolved(this.responseWrapper(response, response.data)))
                 .catch(error => {
                 let message = error.response.data ? error.response.data.error : error.response.statusText
                 rejected(this.errorWrapper(error, message))
                 })
         }),
         new Promise((resolved, rejected) => {
          return this.request({auth: true}).get(`accounts/groups/`)
               .then(response => resolved(this.responseWrapper(response, response.data)))
               .catch(error => {
               let message = error.response.data ? error.response.data.error : error.response.statusText
               rejected(this.errorWrapper(error, message))
               })
        }),
        new Promise((resolved, rejected) => {
          return this.request({auth: true}).get(`infos/proxies/projects/ids`)
               .then(response => resolved(this.responseWrapper(response, response.data)))
               .catch(error => {
               let message = error.response.data ? error.response.data.error : error.response.statusText
               rejected(this.errorWrapper(error, message))
               })
        }),
        new Promise((resolved, rejected) => {
          return this.request({auth: true}).get(`infos/proxies/projects/tags?details=true`)
               .then(response => resolved(this.responseWrapper(response, response.data)))
               .catch(error => {
               let message = error.response.data ? error.response.data.error : error.response.statusText
               rejected(this.errorWrapper(error, message))
               })
        }),
        new Promise((resolved, rejected) => {
          return this.request({auth: true}).get(`infos/language_codes`)
               .then(response => resolved(this.responseWrapper(response, response.data)))
               .catch(error => {
               let message = error.response.data ? error.response.data.error : error.response.statusText
               rejected(this.errorWrapper(error, message))
               })
        }),
        new Promise((resolved, rejected) => {
          return this.request({auth: true}).get(`infos/workers/pools`)
               .then(response => resolved(this.responseWrapper(response, response.data)))
               .catch(error => {
               let message = error.response.data ? error.response.data.error : error.response.statusText
               rejected(this.errorWrapper(error, message))
               })
        }),
      ];

      return Promise.all(promises)
        .then(data => {
          return data;
        });
  }

  loadAllBotsByProject(params) {
    return new Promise((resolved, rejected) => {    
      return this.request({auth: true}).get(`users/current/projects/${params.params.project_id}/bots`)
           .then(response => resolved(this.responseWrapper(response, response.data)))
           .catch(error => {
           let message = '';//error.response.data ? error.response.data.error : error.response.statusText
           rejected(this.errorWrapper(error, message))
           })
   })
  }

  loadReport(params) {
    params.timezone = 'Europe/Moscow';
    return new Promise((resolved, rejected) => {
      return this.request({auth: true}).get(`users/current/statistics/aggr`, {
        params: params
      })
           .then(response => resolved(this.responseWrapper(response, response.data)))
           .catch(error => {
            let message = error.response.data ? error.response.data.error : error.response.statusText
            rejected(this.errorWrapper(error, message))
           })
    })
  }

  loadDayReport (params) {
    params.timezone = 'Europe/Moscow'
    return new Promise((resolved, rejected) => {
      return this.request({ auth: true }).get('users/current/statistics/day-aggr', {
        params: params
      })
        .then(response => resolved(this.responseWrapper(response, response.data)))
        .catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          rejected(this.errorWrapper(error, message))
        })
    })
  }

  loadBotReport(params) {
    params.timezone = 'Europe/Moscow';
    return new Promise((resolved, rejected) => {
      return this.request({auth: true}).get(`users/current/statistics/report`, {
        params: params
      })
           .then(response => resolved(this.responseWrapper(response, response.data)))
           .catch(error => {
            let message = error.response.data ? error.response.data.error : error.response.statusText
            rejected(this.errorWrapper(error, message))
           })
    })
  }

  updateProject(entity) {
    entity = JSON.parse(JSON.stringify(entity));
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.data.id}`, {
        project_id: entity.data.id, 
        name: entity.data.name,
        starting_at: moment(entity.data.daterange[0]).format('YYYY-MM-DD'),
        ending_at: moment(entity.data.daterange[1]).format('YYYY-MM-DD'),
        description: entity.data.description,
        tags: entity.data.tags
      })
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  updateAdvanced(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/settings`, entity)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  createProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/`, {
        name: entity.data.name,
        starting_at: moment(entity.data.starting_at).format('YYYY-MM-DD'),
        ending_at: moment(entity.data.ending_at).format('YYYY-MM-DD')
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  createBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.params.project_id}/bots`, {
        project_id: entity.params.project_id,
        name: entity.params.name,
        goal: 100,
        distributions: {any:100, morning:0, evening:0, night:0, day:0}
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  startBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/start`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  startAllBots(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/start_all_bots`, {
        project_id: entity.project_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  stopAllBots(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/stop_all_bots`, {
        project_id: entity.project_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  stopBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/stop`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deleteBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).delete(`users/current/projects/${entity.params.project_id}/bots/${entity.params.bot_id}`, {
        project_id: entity.params.project_id,
        bot_id: entity.params.bot_id
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deleteProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).delete(`users/current/projects/${entity.params.project_id}`, {
        project_id: entity.params.project_id,
      })
      .then(response => resolve(this.responseWrapper(response, response.data)))
      .catch(error => reject(this.errorWrapper(error)))
    })
  }

  activateProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.params.project_id}/activate`, {
        project_id: entity.params.project_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deactivateProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.params.project_id}/deactivate`, {
        project_id: entity.params.project_id,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  copyProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.project_id}/copy`, {
        project_id: entity.project_id,
        name: entity.name,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  runBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/run-now`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
        tasks: entity.tasks,
        delay: entity.delay,
        repeats: entity.repeats,
        playbook_id: entity.playbook_id,
        video_ratio: entity.video_ratio,
        retry_num: entity.retry_num,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new ProjectsService()
